/* eslint-disable react-hooks/exhaustive-deps */
import { React, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Selector from '../CustomElements/Selector';
import Input from '../CustomElements/Input';
import { handleUniversalChange } from '../../utils/formUtils';
import Accordeon from '../CustomElements/Accordeon';
import useOptionsLoader from '../../customHook/useOptionsLoader';
import {
  initDepartmentOptionsFromServer,
  initOptionsDirectoratesUippsFromServer,
} from '../../redux/actions/options.action';
import { clearMapMarkers } from '../../redux/actions/mapMarkers.action';
import '../../styles/FilterForUipps.css';

function FilterForUipps({
  setIsViewList,
  isViewList,
  setIsViewMap,
  isViewMap,
  formData,
  setFormData,
  showBtnReset,
  resetFilters,
  t,
}) {
  // Получение функции dispatch для отправки действий в Redux store.
  const dispatch = useDispatch();
  // получаем опции из стора
  const optionsForSelect = useSelector((state) => state.options);

  //хук для запроса опций для дирекций и контроля селекта
  const messageForSelectDirectorates = t?.messageForSelectDirectorates || 'Выберите дорогу';
  const directoratesControl = useOptionsLoader(
    formData,
    setFormData,
    ['directorateId', 'departmentId'],
    'roadId',
    initOptionsDirectoratesUippsFromServer,
    messageForSelectDirectorates
  );
  //хук для запроса опций для подразделений и контроля селекта
  const messageForSelectDepartments = t?.messageForSelectDepartments || 'Выберите дирекцию';
  const departmentsControl = useOptionsLoader(
    formData,
    setFormData,
    ['departmentId'],
    'directorateId',
    initDepartmentOptionsFromServer,
    messageForSelectDepartments
  );

  //цвет кнопок, события кнопок
  const [colorBtn, setColorBtn] = useState(false);
  const handleButtonClickList = () => {
    if (!isViewList) {
      setIsViewList((prev) => !prev);
      setIsViewMap((prev) => !prev);
      setColorBtn((prev) => !prev);
      resetFilters();
      dispatch(clearMapMarkers());
    }
  };
  const handleButtonClickMap = () => {
    if (!isViewMap) {
      setIsViewMap((prev) => !prev);
      setIsViewList((prev) => !prev);
      setColorBtn((prev) => !prev);
      dispatch(clearMapMarkers());
      resetFilters();
    }
  };

  return (
    <Accordeon header={t?.uippsControl || 'КОНТРОЛЬ УИППС'} hideAbove={1650} qParamName="uiips_acc">
      <div className="accordeon_buttons__list-map">
        <button
          type="button"
          className={`accordeon_button ${!colorBtn ? 'accordeon_button__active' : ''}`}
          onClick={handleButtonClickList}
        >
          {t?.list || 'Список'}
        </button>
        <button
          type="button"
          className={`accordeon_button ${colorBtn ? 'accordeon_button__active' : ''}`}
          onClick={handleButtonClickMap}
        >
          {t?.map || 'Карта'}
        </button>
      </div>
      <button
        type="button"
        className={`accordeon__reset-filters ${showBtnReset && 'accordeon__reset-filters_visible'}`}
        onClick={resetFilters}
      >
        <span className="accordeon__reset-filters_text">{t?.buttonResetFilters || 'Сбросить все фильтры'}</span>
        <img className="accordeon__reset-filters_icon" src="/image/close.svg" alt=""></img>
      </button>

      <form className="accordeon__form" id="" method="POST" action="#" autoComplete="off">
        <div className="accordeon__select-container" id="">
          <Input
            label={t?.uippsIdLabel || 'ID УИППС'}
            placeholder={t?.uippsIdPlaceholder || 'Введите ID УИППС'}
            onChange={(event) => handleUniversalChange(formData, setFormData, event, null, null, null, null, null, 6)}
            value={formData.id}
            name="id"
          />
          {isViewList && (
            <Selector
              options={optionsForSelect.status}
              onChange={(selectedOption) => {
                handleUniversalChange(formData, setFormData, null, 'online', selectedOption, 'select');
              }}
              placeholder={t?.placeholderSelectStatus || 'Выберите статус'}
              isMulti={false}
              label={t?.labelStatus || 'Статус'}
              value={
                formData.online ? optionsForSelect?.status?.find((option) => option.value === formData.online) : null
              }
              name="online"
            />
          )}
          <Selector
            options={optionsForSelect?.roads}
            onChange={(selectedOption) => {
              handleUniversalChange(formData, setFormData, null, 'roadId', selectedOption, 'select');
            }}
            label={t?.labelRoad || 'Дорога'}
            placeholder={t?.placeholderRoad || 'Выберите дорогу'}
            value={formData.roadId ? optionsForSelect?.roads?.find((option) => option.value === formData.roadId) : null}
            isMulti={false}
            name="roadId"
          />
          <Selector
            options={optionsForSelect?.directoratesUipps}
            onChange={(selectedOption) => {
              handleUniversalChange(formData, setFormData, null, 'directorateId', selectedOption, 'select');
            }}
            value={
              formData?.directorateId
                ? optionsForSelect?.directorates?.find((option) => option.value === formData.directorateId)
                : null
            }
            name="directorateId"
            isMulti={false}
            label={t?.labelDirectorate || 'Дирекция'}
            placeholder={t?.placeholderDirectorate || 'Выберите дирекцию'}
            isDisabled={directoratesControl?.isSelectorDisabled}
            message={directoratesControl?.message}
            customClick={directoratesControl?.onSelectorChange}
          />
          <Selector
            options={optionsForSelect?.departments}
            onChange={(selectedOption) => {
              handleUniversalChange(formData, setFormData, null, 'departmentId', selectedOption, 'select');
            }}
            value={
              formData?.departmentId
                ? optionsForSelect?.departments?.find((option) => option.value === formData.departmentId)
                : null
            }
            name="departmentId"
            isMulti={false}
            label={t?.labelDepartment || 'Подразделение'}
            placeholder={t?.placeholderDepartment || 'Выберите № подразделения'}
            isDisabled={departmentsControl?.isSelectorDisabled}
            message={departmentsControl?.message}
            customClick={departmentsControl?.onSelectorChange}
          />
          <Selector
            options={optionsForSelect?.trainTypes}
            onChange={(selectedOption) => {
              handleUniversalChange(formData, setFormData, null, 'trainTypeId', selectedOption, 'select');
            }}
            value={
              formData?.trainTypeId
                ? optionsForSelect?.trainTypes?.find((option) => option.value === formData.trainTypeId)
                : null
            }
            name="trainTypeId"
            isMulti={false}
            label={t?.trainTypeLabel || 'Тип подвижного состава'}
            placeholder={t?.trainTypePlaceholder || 'Выберите тип ПС'}
          />
          <Input
            onChange={(event) => handleUniversalChange(formData, setFormData, event, null, null, null, null, null, 15)}
            value={formData?.trainNumberId}
            name="trainNumberId"
            label={t?.trainNumberLabel || 'Номер подвижного состава'}
            placeholder={t?.trainNumberPlaceholder || 'Введите № локомотива'}
          />
          <Input
            onChange={(event) => handleUniversalChange(formData, setFormData, event, null, null, null, null, null, 15)}
            value={formData?.responsible}
            name="responsible"
            label={t?.driverNumberLabel || 'Табельный номер машиниста'}
            placeholder={t?.driverNumberPlaceholder || 'Введите № машиниста'}
          />
        </div>
      </form>
    </Accordeon>
  );
}

export default FilterForUipps;
